import React, { createContext, useContext, useState, useEffect } from 'react';
import { getUserInfoService } from '../services/authService';

interface AuthContextType {
    role: string | null;
    setRole: React.Dispatch<React.SetStateAction<string | null>>;
    fetchingRole: boolean;
    fetchRole: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
    const [role, setRole] = useState<string | null>(null);
    const [fetchingRole, setFetchingRole] = useState<boolean>(true);

    const fetchRole = async () => {
        setFetchingRole(true);
        try {
            const response = await getUserInfoService();
            const userRole = response.data.data.role.toLowerCase().replace(/_/g, '');
            setRole(userRole);
        } catch (error: any) {
            console.error('Failed to fetch user role:', error.message);
            setRole(null);
        } finally {
            setTimeout(() => setFetchingRole(false), 600);
        }
    };

    useEffect(() => {
        fetchRole();
    }, []);

    return (
        <AuthContext.Provider value={{ role, setRole, fetchingRole, fetchRole }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuthContext = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuthContext must be used within an AuthProvider');
    }
    return context;
};
